<template>
  <div class="list-imei">
    <KTCodePreview v-bind:title="'Danh sách số khung, số máy'">
      <template v-slot:toolbar>
        <b-row>
          <b-dropdown size="sm" right>
            <template slot="button-content">
              <i style="font-size: 1rem" class="fas fa-cog"></i>
              <span class="font-weight-bolder">Thao tác</span>
            </template>
            <b-dropdown-item
              v-if="checkPermission('PRODUCT_EXPORT')"
              @click="excelModal"
            >
              <span>
                <i style="font-size: 1rem" class="far fa-file-excel"></i>
                &nbsp; Xuất Excel</span
              >
            </b-dropdown-item>
          </b-dropdown>
        </b-row>
      </template>
      <template v-slot:preview>
        <b-row class="mb-5">
          <b-col>
            <b-input
              size="sm"
              placeholder="Nhập mã số khung / số máy"
              v-model="search"
              append-icon="search"
              single-line
              hide-details
              v-on:keyup.enter="onFilter()"
            ></b-input>
          </b-col>
          <b-col>
            <b-input
              size="sm"
              placeholder="Nhập mã, tên sản phẩm"
              v-model="searchProduct"
              append-icon="search"
              single-line
              hide-details
              v-on:keyup.enter="onFilter()"
            ></b-input>
          </b-col>
          <b-col>
            <BDropdownCustom
              v-model="valueStatus"
              :options="filterdOptionStatus"
              :placeholder="'trạng thái'"
              :matchKey="['name']"
              :searchable="true"
              :limit="5"
            />
          </b-col>
          <b-col>
            <Autosuggest
              :model="searchProvider"
              :suggestions="filteredOptionProvider"
              placeholder="NCC"
              @select="onSelectedProvider"
              @change="onInputChangeProvider"
            />
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <!-- <b-col>
            <Autosuggest
              :model="searchStock"
              :suggestions="filteredOptions"
              placeholder="cửa hàng"
              @select="onSelected"
              @change="onInputChangeStore"
            />
          </b-col> -->
          <b-col>
            <BDropdownCustom
              v-model="selectedStores"
              :options="filterdOptionsStore"
              :placeholder="'cửa hàng'"
              :matchKey="['name']"
              :searchable="true"
            />
          </b-col>
          <b-col>
            <div class="search-col">
              <b-input-group>
                <date-picker
                  placeholder="Từ"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="searchFromDay"
                ></date-picker>
              </b-input-group>
              <span class="ml-1 mr-1"></span>
              <b-input-group>
                <date-picker
                  placeholder="Đến"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="searchToDay"
                ></date-picker>
              </b-input-group>
            </div>
          </b-col>

          <b-col></b-col>
          <b-col></b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col md="1">
            <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc</b-button
            >
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <p
                class="mt-3 text-dark"
                style="font-weight: 500; font-size: 13px"
              >
                {{ fromNo }} - {{ toNo }} /
                {{ convertPrice(totalItem) }}
              </p>
            </div>
          </b-col>
        </b-row>

        <b-table
          :items="listImeis"
          :fields="fields"
          bordered
          hover
          :busy="onLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>
          <template v-slot:head(selected)>
            <span>
              <b-form-checkbox
                v-model="checkAllPro"
                @change="checkAll"
                size="lg"
              ></b-form-checkbox>
            </span>
          </template>
          <template v-slot:cell(selected)="row">
            <div class="d-flex justify-content-center">
              <b-form-checkbox
                size="lg"
                v-model="row.item.selected"
                @change="clickIndex"
              ></b-form-checkbox>
            </div>
          </template>
          <template v-slot:cell(productName)="row">
            <span
              v-if="row.item.barCode"
              v-text="row.item.barCode"
              style="white-space: normal; font-size: 12px; font-weight: 500"
            ></span>
            <p
              v-if="row.item.productCode"
              style="font-size: 12px; font-weight: 500; margin-bottom: 0"
            >
              ( {{ row.item.productCode }} )
            </p>
            <span
              v-text="row.item.productName"
              style="white-space: normal"
            ></span>
            <div>
              <MerchantLabel :merchantId="row.item.merchantId" />
            </div>
          </template>
          <template v-slot:cell(provider)="row">
            <p
              v-if="row.item.provider && row.item.provider.name"
              style="font-size: 13px; font-weight: 4500; margin-bottom: 0"
            >
              {{ row.item.provider.name }}
            </p>
            <span
              v-text="formatDate(row.item.createdAt)"
              style="white-space: normal; color: blue"
            ></span>
          </template>
          <template v-slot:cell(chassisEngine)="row">
            <div class="row">
              <div
                class="imeiCode col-md-10"
                style="cursor: pointer"
                title="Xem lịch sử sản phẩm"
                @click="goToProductHistory(row.item.chassisNumber)"
              >
                SK: <span v-text="row.item.chassisNumber"></span>
              </div>
              <i
                class="fas fa-copy ml-4"
                style="cursor: pointer; font-size: 11px"
                v-clipboard:copy="row.item.chassisNumber"
                title="Copy to clipboard"
                @click="makeToastSuccess('Copied to clipboard!')"
              ></i>
            </div>

            <div class="row">
              <div
                class="imeiCode col-md-10"
                style="cursor: pointer"
                title="Xem lịch sử sản phẩm"
                @click="goToProductHistory(row.item.chassisNumber)"
              >
                SM: <span v-text="row.item.engineNumber"></span>
              </div>
              <i
                class="fas fa-copy ml-4"
                style="cursor: pointer; font-size: 11px"
                v-clipboard:copy="row.item.engineNumber"
                title="Copy to clipboard"
                @click="makeToastSuccess('Copied to clipboard!')"
              ></i>
            </div>
          </template>
          <template v-slot:cell(store)="row">
            {{
              row.item.store && row.item.store.name ? row.item.store.name : '—'
            }}
          </template>
          <template v-slot:cell(status)="row">
            <div class="ce-status-cell">
              <span
                v-text="displayStatusLabel(row.item)"
                class="label font-weight-bold label-lg label-inline"
                v-bind:class="displayStatusClass(row.item)"
                style="width: max-content"
              ></span>
              <div
                v-if="row.item.status === 'SALED' && row.item.billNumber"
                class="ce-doc-ref"
              >
                <span class="ce-doc-label">Hóa đơn:</span>
                <a
                  href="javascript:void(0)"
                  class="ce-contract-link"
                  @click="goToBill(row.item.billNumber)"
                >
                  #{{ row.item.billNumber }}
                </a>
              </div>
              <div
                v-else-if="
                  row.item.status === 'ON_HOLDING' && row.item.contractNumber
                "
                class="ce-doc-ref"
              >
                <span class="ce-doc-label">HĐMB:</span>
                <a
                  href="javascript:void(0)"
                  class="ce-contract-link"
                  @click="goToContract(row.item.contractId)"
                >
                  {{ row.item.contractNumber }}
                </a>
              </div>
              <!-- Ngày ghép xe → click sang lịch sử sản phẩm (full vòng đời) -->
              <div
                v-if="row.item.status === 'ON_HOLDING' && row.item.allocateDate"
                class="ce-doc-ref"
              >
                <span class="ce-doc-label">Ngày ghép:</span>
                <a
                  href="javascript:void(0)"
                  class="ce-contract-link"
                  title="Xem lịch sử sản phẩm"
                  @click="goToProductHistory(row.item.chassisNumber)"
                >
                  {{ formatDate(row.item.allocateDate) }}
                </a>
              </div>
            </div>
          </template>
          <template v-slot:cell(originalPrice)="row">
            <div style="text-align: end">
              <span v-text="convertPrice(row.item.originalPrice)"></span>
            </div>
          </template>
          <template v-slot:cell(sellingPrice)="row">
            <div
              @mouseover="hoverPrice = true"
              @mouseleave="hoverPrice = false"
              style="text-align: end; cursor: pointer"
            >
              <span v-text="convertPrice(row.item.sellingPrice)"></span>
            </div>
          </template>

          <template v-slot:cell(actions)="row">
            <div
              class="d-flex justify-content-center"
              v-if="canEditEngine(row.item)"
            >
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i>
                </template>
                <!-- Edit Engine Number -->
                <b-dropdown-item @click="showEditEngineModal(row.item)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="fas fa-wrench"></i>
                    &nbsp; Chỉnh sửa số máy
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
          <!-- <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i>
                </template>
                <b-dropdown-item
                  @click="editItem(row.item)"
                  v-if="checkViewOnly()"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon-eye"></i>
                    &nbsp; Chi tiết sản phẩm
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="editItem(row.item)"
                  v-if="!checkViewOnly()"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-pen"></i>
                    &nbsp; Chỉnh sửa
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="showActiveModal(row.item.imeiCode)"
                  v-if="!checkViewOnly()"
                  v-show="checkPermission('ACTIVE_IMEI')"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="fa fa-check"></i>
                    &nbsp; Kích hoạt
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template> -->
        </b-table>

        <b-row>
          <b-col>
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng số:
              {{ convertPrice(totalItem) }}
            </p>
          </b-col>
          <div class="d-flex justify-content-end">
            <b-col>
              <BPaginationNavCustom
                :number-of-pages="numberOfPage || 1"
                :current-page="page"
                :total-page="totalItem"
                @page-change="fetchData"
              ></BPaginationNavCustom>
            </b-col>
          </div>
        </b-row>
      </template>
    </KTCodePreview>

    <ActiveImei ref="active-imei-modal" />

    <EditEngineNumberModal
      ref="edit-engine-modal"
      :productItem="selectedProductForEdit"
      @engineNumberUpdated="handleEngineNumberUpdated"
    />
  </div>
</template>

<style lang="scss">
.list-imei {
  .labelInput {
    font-weight: 600;
  }
  .productCode:hover {
    text-decoration: underline;
  }
  .ce-status-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
  .ce-doc-ref {
    font-size: 12px;
    white-space: nowrap;
  }
  .ce-doc-label {
    color: #64748b;
    margin-right: 2px;
  }
  .ce-contract-link {
    color: #3699ff;
    font-weight: 600;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  .inputText {
    width: 22%;
  }

  .page-item.disabled {
    cursor: not-allowed;
    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }

  .icon:hover {
    background-color: #90c6fc;
  }

  .selectedProClass {
    width: 4%;
    text-align: center;
  }
  .productNameClass {
    width: 20%;
  }
  .productNameNotPriceClass {
    width: 20%;
  }
  .imeiClass {
    width: 15%;
  }
  .providerClass {
    width: 15%;
  }
  .storeClass {
    width: 10%;
    align-items: center;
  }
  .importPriceProClass {
    width: 10%;
  }
  .salePriceProClass {
    width: 10%;
  }
  .statusProClass {
    width: 10%;
    text-align: center;
  }
  .dropdown-header {
    color: #3699ff !important;
  }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }
  .table.b-table.table-sm
    > thead
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left),
  .table.b-table.table-sm
    > tfoot
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left) {
    background-position: right calc(1.5rem / 2) center;
    padding-right: calc(0.3rem + 0.65em);
  }
  a {
    width: 100%;
  }

  .imeiCode:hover {
    text-decoration: underline;
  }
  .test {
    position: absolute;
    right: 1vw;
  }
  .checkbox-label {
    display: block;
  }

  .search-col {
    display: flex;
    align-items: center;
  }
}
</style>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import Swal from 'sweetalert2';
import ApiService from '@/core/services/api.service';
import localData from '@/utils/saveDataToLocal';
import { VclTable } from 'vue-content-loading';
import {
  currencyMask,
  xoa_dau,
  removeAccents,
  convertPrice,
  makeToastFaile,
} from '@/utils/common';
import decounce from 'debounce';
import { TIME_TRIGGER } from '@/utils/constants';
import ActiveImei from '@/view/components/imeis/ActiveImei';
import MerchantLabel from '@/view/components/MerchantLabel';

import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { cloneDeep, map, find, assign } from 'lodash';
import { getToastInstance } from '@/utils/toastHelper';
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
// import Treeselect from '@riophae/vue-treeselect';
// import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { getStartOfDay, getEndOfDay } from '@/utils/date';
import moment from 'moment';
import fileDownload from '@/utils/file-download';
import EditEngineNumberModal from '@/view/components/chassis-engine/EditEngineNumberModal.vue';
import { handleApiError } from '../../../utils/errorHandler';

import {
  PRODUCT_CHASSIS_SERIES_STATUS,
  EMPTY_ENGINE_NUMBER,
} from '@/utils/enum';

export default {
  data() {
    return {
      selectedProvider: null,
      PRODUCT_CHASSIS_SERIES_STATUS,
      EMPTY_ENGINE_NUMBER,
      listProvider: [],
      btnCreate: {
        fontWeight: '600!important',
      },
      selected: [],
      checkAllPro: false,
      fields: [
        {
          key: 'selected',
          label: '',
          thStyle: { textAlign: 'center' },
          tdClass: 'selectedProClass',
          thClass: 'selectedProClass',
        },
        {
          key: 'productName',
          label: 'Sản phẩm',
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
        },
        {
          key: 'chassisEngine',
          label: 'Số khung / số máy',
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
        },
        {
          key: 'provider',
          label: 'Nhà cung cấp',
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
        },
        {
          key: 'store',
          label: 'Kho',
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
        },
        {
          key: 'originalPrice',
          label: 'Giá nhập',
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          tdClass: 'statusProClass',
          thClass: 'statusProClass',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      search: '',
      listImeis: [],
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      page: 1,
      totalItem: 0,
      listStatus: [
        { id: '', name: 'Tất cả trạng thái' },
        { id: 'NEW', name: 'Mới' },
        { id: 'SALED', name: 'Đã bán' },
        { id: 'TRANSFERING', name: 'Đang vận chuyển' },
        { id: 'ERROR', name: 'Lỗi' },
        { id: 'RETURN_TO_SUPPLIER', name: 'Đã trả NCC' },
        { id: 'STOCK_TRANSFER', name: 'Đang chuyển kho' },
        { id: 'EXPORT_WARRANTY', name: 'Đã trả bảo hành' },
        { id: 'ON_WARRANTY', name: 'Đang bảo hành' },
        { id: 'ON_HOLDING', name: 'Đang giữ hàng' },
        { id: 'LENDING', name: 'Đang cho mượn' },
        { id: 'LOSS', name: 'Thất thoát' },
        { id: 'IN_DEMO', name: 'Đang sử dụng' },
      ],
      onLoading: false,
      numberOfPage: 0,
      filteredOptions: [],
      suggestionStoreForOldImeiList: [],
      optionsStore: [
        {
          data: [],
        },
      ],
      searchProduct: '',
      showEditPriceModal: false,
      mask: currencyMask,
      listStore: [],
      selectedStore: null,
      selectedStores: [],
      filterdOptionsStore: [],
      selectedStoreForOldImeiList: null,
      searchStock: '',
      selectedRowExcel: 'all',
      showHeaderExcel: false,
      filteredOptionProvider: [],
      optionsProvider: [
        {
          data: [],
        },
      ],
      searchProvider: '',
      fromNo: 0,
      toNo: 0,
      LIMIT_PAGE: 30,
      cateOptions: [
        {
          data: [],
        },
      ],
      filteredCateOptions: [],
      selectedCateId: null,

      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      searchFromDay: '',
      searchToDay: '',
      valueStatus: [],
      optionsStatus: [
        {
          code: 'NEW',
          name: 'Mới',
          shortName: 'Mới',
          checked: false,
        },
        {
          code: 'PO_ORDERED',
          name: 'Đang đặt (PO)',
          shortName: 'Đang đặt (PO)',
          checked: false,
        },
        {
          code: 'ON_HOLDING_PENDING_IMPORT',
          name: 'Giữ chỗ · chờ về',
          shortName: 'Chờ về',
          checked: false,
        },
        {
          code: 'SALED_PENDING',
          name: 'Đã bán · chờ giao',
          shortName: 'Chờ giao',
          checked: false,
        },
        {
          code: 'SALED_DELIVERED',
          name: 'Đã bán · đã giao',
          shortName: 'Đã giao',
          checked: false,
        },
        {
          code: 'TRANSFERING',
          name: 'Đang vận chuyển',
          shortName: 'Đang vận chuyển',
          checked: false,
        },
        {
          code: 'ERROR',
          name: 'Lỗi',
          shortName: 'Lỗi',
          checked: false,
        },
        {
          code: 'RETURN_TO_SUPPLIER',
          name: 'Đã trả NCC',
          shortName: 'Đã trả NCC',
          checked: false,
        },
        {
          code: 'STOCK_TRANSFER',
          name: 'Đang chuyển kho',
          shortName: 'Đang chuyển kho',
          checked: false,
        },
        {
          code: 'EXPORT_WARRANTY',
          name: 'Đã trả bảo hành',
          shortName: 'Đã trả bảo hành',
          checked: false,
        },
        {
          code: 'ON_WARRANTY',
          name: 'Đang bảo hành',
          shortName: 'Đang bảo hành',
          checked: false,
        },
        {
          code: 'ON_HOLDING',
          name: 'Đang giữ hàng',
          shortName: 'Đang giữ hàng',
          checked: false,
        },
        {
          code: 'LENDING',
          name: 'Đang cho mượn',
          checked: false,
        },
        {
          code: 'LOSS',
          name: 'Thất thoát',
          checked: false,
        },
        {
          code: 'IN_DEMO',
          name: 'Đang sử dụng',
          checked: false,
        },
      ],
      filterdOptionStatus: [],
      selectedProductForEdit: null,
    };
  },
  components: {
    KTCodePreview,
    VclTable,
    ActiveImei,
    Autosuggest,
    MerchantLabel,
    BDropdownCustom,
    EditEngineNumberModal,
    BPaginationNavCustom,
    // Treeselect,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Danh sách số khung, số máy' },
    ]);
  },
  created() {
    let imeiCode = this.$route.query.code;
    let searchProduct = this.$route.query.searchProduct;
    let storeId = this.$route.query.storeId;
    if (imeiCode !== undefined) {
      this.search = imeiCode;
    }
    if (searchProduct !== undefined) {
      this.searchProduct = searchProduct;
    }
    if (storeId !== undefined) {
      this.selectedStore = storeId;
    }
    this.fetchData();
    this.fetchProvider();
    this.checkViewOriginalPrice();
    this.fetchStore();
  },
  computed: {
    canEditEngine() {
      return (item) => {
        return (
          (item.status === this.PRODUCT_CHASSIS_SERIES_STATUS.NEW ||
            item.status === this.PRODUCT_CHASSIS_SERIES_STATUS.ON_HOLDING) &&
          this.checkPermission(['PRODUCT_UPDATE_ENGINE_NUMBER']) &&
          item.engineNumber === this.EMPTY_ENGINE_NUMBER
        );
      };
    },
  },
  methods: {
    excelModal: async function () {
      let listStatus = [];
      if (this.valueStatus.length) {
        listStatus = this.valueStatus.map(({ code }) =>
          code === 'SALED_PENDING' || code === 'SALED_DELIVERED'
            ? 'SALED'
            : code,
        );
        listStatus = [...new Set(listStatus)];
      }
      const param = {
        page: this.page,
        limit: this.LIMIT_PAGE,
        status: listStatus,
        search: this.search ? this.search.trim() : '',
        searchId: this.searchId,
        providerId: this.selectedProvider,
        searchName: this.searchProduct,
        storeId: this.selectedStore,
        fromDate: getStartOfDay(this.searchFromDay),
        toDate: getEndOfDay(this.searchToDay),
      };
      const paramQuery = {
        params: param,
        responseType: 'blob',
      };
      ApiService.query('/products/export-excel-chassis-engine', paramQuery)
        .then((response) => {
          const fileName = fileDownload.getFileName(response);
          fileDownload.createFile(response.data, fileName);
          this.isDownloading = false;
        })
        .catch((err) => {
          this.isDownloading = false;
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }

          this.$nprogress.done();
        });
    },
    formatDate: function (dateVal) {
      const date = moment(dateVal);
      return date.format('DD/MM/yyyy');
    },
    getStatusColor(status) {
      const MAP_COLOR = {
        NEW: 'label-light-warning',
        SALED: 'label-light-success',
        TRANSFERING: 'label-light-danger',
        ERROR: 'label-light-default',
        LENDING: 'label-light-info',
        IN_DEMO: 'label-light-info',
        ON_HOLDING: 'label-light-primary',
        PO_ORDERED: 'label-light-info',
        ON_HOLDING_PENDING_IMPORT: 'label-light-info',
        PENDING_RECEIPT: 'label-light-warning',
        RETURN_TO_SUPPLIER: 'label-light-danger',
      };

      return MAP_COLOR[status] || 'label-light-default';
    },
    displayStatusLabel(item) {
      if (item.status === 'SALED') {
        return item.deliveryState === 'PENDING'
          ? 'Đã bán · chờ giao'
          : 'Đã bán · đã giao';
      }
      return this.checkStatus(item.status);
    },
    displayStatusClass(item) {
      if (item.status === 'SALED' && item.deliveryState === 'PENDING') {
        return 'label-light-warning';
      }
      return this.getStatusColor(item.status);
    },
    goToContract(contractId) {
      if (!contractId) return;
      const route = this.$router.resolve({
        name: 'edit-contract',
        params: { id: contractId },
      });
      window.open(route.href, '_blank');
    },
    goToBill(billNumber) {
      if (!billNumber) return;
      const route = this.$router.resolve({
        name: 'update-bill',
        query: { id: billNumber },
      });
      window.open(route.href, '_blank');
    },
    // Sang trang lịch sử sản phẩm, lọc sẵn theo số khung (full vòng đời xe).
    goToProductHistory(chassisNumber) {
      if (!chassisNumber) return;
      const route = this.$router.resolve({
        name: 'product-history.list',
        query: { searchChassisEngine: chassisNumber },
      });
      window.open(route.href, '_blank');
    },
    convertPrice,
    ...getToastInstance(),
    checkStatus: function (item) {
      switch (item) {
        case 'NEW':
          return 'Mới';
        case 'SALED':
          return 'Đã bán';
        case 'TRANSFERING':
          return 'Đang vận chuyển';
        case 'ERROR':
          return 'Lỗi';
        case 'RETURN_TO_SUPPLIER':
          return 'Đã trả NCC';
        case 'STOCK_TRANSFER':
          return 'Đang chuyển kho';
        case 'EXPORT_WARRANTY':
          return 'Đã trả bảo hành';
        case 'ON_WARRANTY':
          return 'Đang bảo hành';
        case 'ON_HOLDING':
          return 'Đang giữ hàng';
        case 'PO_ORDERED':
          return 'Đang đặt (PO)';
        case 'ON_HOLDING_PENDING_IMPORT':
          return 'Giữ chỗ · chờ về';
        case 'PENDING_RECEIPT':
          return 'Chờ xác nhận nhận';
        case 'LENDING':
          return 'Đang cho mượn';
        case 'LOSS':
          return 'Thất thoát';
        case 'IN_DEMO':
          return 'Đang sử dụng';
        default:
          return '';
      }
    },
    checkViewOnly: function () {
      let count = 0;
      if (localData.checkPermission('PRODUCT_VIEW')) {
        count++;
      }
      if (localData.checkPermission('PRODUCT_UPDATE')) {
        count++;
      }
      if (count === 1) {
        return true;
      } else {
        return false;
      }
    },
    showDeleteAlert: function (item) {
      Swal.fire({
        title: 'Xóa sản phẩm!',
        text: 'Bạn có chắc muốn xóa sản phẩm này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.deleteItem(item);
        }
      });
    },
    deleteItem: function (item) {
      alert(item);
    },
    fetchData: function () {
      this.onLoading = true;
      this.page = this.$route.query.page;

      if (!this.page) {
        this.page = 1;
      }

      let storeIds = [];
      if (this.selectedStores && this.selectedStores.length > 0) {
        storeIds = this.selectedStores.map((store) => store.code);
      }

      if (this.searchStock.trim() === '') {
        this.selectedStore = null;
      }

      let listStatus = [];
      let deliveryState;
      if (this.valueStatus.length) {
        const codes = this.valueStatus.map(({ code }) => code);
        const wantPending = codes.includes('SALED_PENDING');
        const wantDelivered = codes.includes('SALED_DELIVERED');
        listStatus = codes.filter(
          (c) => c !== 'SALED_PENDING' && c !== 'SALED_DELIVERED',
        );
        if (wantPending || wantDelivered) listStatus.push('SALED');
        if (wantPending && !wantDelivered) deliveryState = 'PENDING';
        else if (wantDelivered && !wantPending) deliveryState = 'DELIVERED';
      }
      this.filterdOptionStatus = cloneDeep(this.optionsStatus);
      const param = {
        page: this.page,
        limit: this.LIMIT_PAGE,
        status: listStatus,
        deliveryState: deliveryState || undefined,
        search: this.search ? this.search.trim() : '',
        providerId: this.selectedProvider,
        searchName: this.searchProduct,
        // storeId: this.selectedStore,
        storeIds,
        fromDate: getStartOfDay(this.searchFromDay),
        toDate: getEndOfDay(this.searchToDay),
      };
      const paramQuery = {
        params: param,
      };
      ApiService.query('products/chassis-engine', paramQuery)
        .then(({ data }) => {
          this.listImeis = [];
          this.numberOfPage = data.data.paginations.totalPages;
          this.totalItem = data.data.paginations.total;
          this.fromNo = (this.page - 1) * this.LIMIT_PAGE + 1;
          this.toNo = this.LIMIT_PAGE * this.page;
          if (this.toNo > this.totalItem) {
            this.toNo = this.totalItem;
          }
          data.data.data.forEach((element) => {
            let item = {
              id: element.id,
              barCode: element.barCode,
              productCode: element.product.code,
              productName: element.product.name,
              engineNumber: element.engineNumber,
              chassisNumber: element.chassisNumber,
              provider: element.provider,
              store: element.store,
              originalPrice: element.importPrice,
              sellingPrice: element.sellingPrice,
              status: element.status,
              deliveryState: element.deliveryState || null,
              contractId: element.contract ? element.contract.id : null,
              contractNumber: element.contract
                ? element.contract.contractNumber
                : null,
              allocateDate: element.contract
                ? element.contract.confirmDate
                : null,
              billId: element.bill ? element.bill.id : null,
              billNumber: element.bill ? element.bill.billNumber : null,
              selected: false,
              createdAt: element.createdAt,
              merchantId: element.merchantId,
            };
            this.listImeis.push(item);
          });
          this.onLoading = false;
        })
        .catch((error) => {
          this.onLoading = false;
          if (error.response) {
            makeToastFaile(
              error.response.data ? error.response.data.message : 'Lỗi',
            );
          } else {
            makeToastFaile(error.message || 'Lỗi');
          }
        });
    },
    editItem: function (item) {
      this.$router.push({
        name: 'update-imei',
        query: { id: item.id },
      });
    },
    checkPermission: function (condition) {
      return localData.checkPermission(condition);
    },
    fetchProvider() {
      ApiService.setHeader();
      ApiService.get(`providers?limit=100000000`).then(({ data }) => {
        this.listProvider = data.data.data;
        let noneProvider = {
          id: null,
          name: 'Tất cả',
        };
        this.listProvider.unshift(noneProvider);
        this.listProvider.forEach((element) => {
          this.optionsProvider[0].data.push(element);
        });
        this.filteredOptionProvider = [...this.optionsProvider[0].data];
      });
    },
    onSelected(option) {
      this.searchStock = option.item.name;
      this.selectedStore = option.item.id;
      this.onFilter();
    },

    onInputChangeStore(text) {
      if (!text) {
        text = '';
      }
      this.searchStock = text;

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.optionsStore[0].data.filter((item) => {
        return (
          item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
          item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
        );
      });

      this.filteredOptions = [...filteredData];
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.name;
    },

    debounceInput: decounce(function () {
      this.onFilter();
    }, TIME_TRIGGER),
    checkViewOriginalPrice() {
      if (!this.checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')) {
        let listNew = this.fields.filter(
          (item) => item.key !== 'originalPrice',
        );
        this.fields = [];
        listNew.forEach((element) => {
          this.fields.push(element);
        });
        for (let index = 0; index < this.fields.length; index++) {
          const element = this.fields[index];
          if (element.key === 'productName') {
            this.fields[index].tdClass = 'productNameNotPriceClass';
            this.fields[index].thClass = 'productNameNotPriceClass';
            break;
          }
        }
      }
    },
    fetchStore: async function () {
      this.filterdOptionsStore = [];

      ApiService.query('stores/get-by-user')
        .then((response) => {
          const stores = response.data?.data?.stores || [];
          const storeOptions = [];

          stores.forEach((element) => {
            const option = {
              id: element.id,
              code: element.id,
              name: element.shortName,
              shortName: element.shortName,
            };

            storeOptions.push(option);
          });

          this.filterdOptionsStore = storeOptions;

          // Chọn tất cả stores
          this.selectedStores = [...storeOptions];
        })
        .catch((error) => {
          makeToastFaile(
            error.response?.data?.message ||
              error.message ||
              'Lỗi khi lấy danh sách cửa hàng',
          );
        });
    },
    onFilter() {
      this.$route.query.page = 1;

      this.fetchData();
    },
    showHeader() {
      if (this.selectedRowExcel === 'row') {
        this.showHeaderExcel = true;
      } else {
        this.showHeaderExcel = false;
      }
    },
    onSelectedProvider(option) {
      this.searchProvider = option.item.name;
      this.selectedProvider = option.item.id;
    },
    onInputChangeProvider(text) {
      if (!text) {
        text = '';
      }
      this.searchProvider = text;

      const filteredData = this.optionsProvider[0].data.filter((item) => {
        let itemName = xoa_dau(item.name);
        return itemName.toLowerCase().indexOf(text.toLowerCase()) > -1;
      });

      this.filteredOptionProvider = [...filteredData];
    },

    onInputStatusChange(textInput = '') {
      this.searchStatus(textInput);
    },
    searchStatus(textInput) {
      let options = cloneDeep(this.optionsStatus);
      if (!textInput || !textInput.trim().length) {
        this.filterdOptionStatus = map(options, (obj) => {
          return assign(obj, find(this.filterdOptionStatus, { id: obj.id }));
        });
        return;
      }

      const indexChooseAll = options.findIndex((prop) => prop.id === -1);

      if (indexChooseAll > -1) {
        options.splice(indexChooseAll, 1);
      }

      options = map(options, (obj) => {
        return assign(obj, find(this.filterdOptionStatus, { id: obj.id }));
      });

      this.filterdOptionStatus = this.fitlerOptionsBy(
        options,
        textInput,
        'name',
        10,
      );
    },
    fitlerOptionsBy(items, textInput, prop, limit) {
      return cloneDeep(items)
        .filter((item) => {
          if (item) {
            const nameWTUnicode = removeAccents(item[prop] || '');
            const nameInputWTUnicode = removeAccents(textInput);
            const index = nameWTUnicode
              .toLowerCase()
              .indexOf(nameInputWTUnicode.toLowerCase());

            if (index > -1) {
              return true;
            }
          }
          return false;
        })
        .slice(0, limit);
    },
    onSelectStatus(option) {
      const index = this.optionsStatus.findIndex(
        (item) => item.name == option.name,
      );
      this.optionsStatus[index].checked = true;
      this.filterdOptionStatus = cloneDeep(this.optionsStatus);
    },
    onRemoveStatus(option) {
      const index = this.optionsStatus.findIndex(
        (item) => item.name == option.name,
      );
      this.optionsStatus[index].checked = false;
      this.filterdOptionStatus = cloneDeep(this.optionsStatus);
    },
    customLabelStatus(option) {
      return `${option.name}`;
    },
    showActiveModal(imeiCode) {
      this.$refs['active-imei-modal'].showModal(imeiCode);
    },
    checkAll() {
      this.listImeis.forEach((element) => {
        element.selected = this.checkAllPro;
      });
    },
    clickIndex() {
      if (this.checkAllPro == true) {
        this.checkAllPro = false;
      } else {
        var count = 0;
        this.listImeis.forEach((element) => {
          if (element.selected == true) {
            count += 1;
            if (count == 10) {
              this.checkAllPro = true;
            }
          }
        });
      }
    },

    showEditEngineModal(item) {
      this.selectedProductForEdit = { ...item };
      this.$nextTick(() => {
        this.$refs['edit-engine-modal'].showModal();
      });
    },

    async handleEngineNumberUpdated() {
      try {
        await this.fetchData();
      } catch (error) {
        handleApiError(error);
      } finally {
        this.selectedProductForEdit = null;
      }
    },
  },
};
</script>
